import { ModelTranslator } from '@/types/ApiResponseTypes'
import { mobileUsageRequestBody } from '@/types/mobile/MobileUsageResponse'
import { isMobileUsageRequest } from '@/types/mobile/MobileUsageType'

class MobileUsageRequestBodyTranslator implements ModelTranslator<mobileUsageRequestBody> {
  convertToModel(model: any): mobileUsageRequestBody {
    if (isMobileUsageRequest(model)) {
      return {
        dateFrom: this.convertDateToString(model.dateFrom),
        dateTo: this.convertDateToString(model.dateTo),
        period: model.period == 'day' ? 'day' : 'month',
        subscriber: model.subscriber,
      }
    }
    return { dateFrom: '', dateTo: '', period: '', subscriber: '' }
  }

  convertDateToString(time: Date | undefined): string {
    if (time == undefined) return ''

    const year = time.getFullYear().toString()
    const month = (time.getMonth() + 1).toString().padStart(2, '0')
    const day = time.getDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}

export default new MobileUsageRequestBodyTranslator()
